import { useState, useEffect } from 'react';

// 脳内化学タイプのデータ
const brainTypes = [
  {
    id: 1,
    name: 'ノルアドレナリンタイプ',
    subtitle: '突破・決断・行動の人',
    icon: 'ri-flashlight-fill',
    color: '#1e3a8a',
    comments: [
      '小さな一歩が大きな突破口に。まず動くが勝ちの日。',
      '即断即決が吉。決める力が評価につながります。',
      'トラブル対応で光る日。あなたの初動がチームの鍵。',
      '一歩だけスピードを落とすと協力者が増えます。',
      '午前中の短時間集中が最高の成果を呼びます。',
      '行動が信頼を生む日。早めの声かけが運を開く。',
      '改善提案が通りやすい日。思いつきを言語化して。',
      '飛ばしすぎ注意。休憩の確保がパフォーマンスを守る。',
      '小さな挑戦が運気を変える日。やってみようを一つ。',
      '午後から加速。午前は整理、午後は行動が吉。'
    ]
  },
  {
    id: 2,
    name: 'アドレナリンタイプ',
    subtitle: '瞬発・集中・勝負の人',
    icon: 'ri-fire-fill',
    color: '#f97316',
    comments: [
      '"ここぞ"の集中が光る日。短期勝負で結果が出ます。',
      '火事場の馬鹿力が発揮される日。急ぎ案件に強い。',
      '突発的な仕事が運気の入り口に。逃さずつかんで。',
      '迷う前に手を動かすと状況が好転します。',
      '勝負どころは午後。集中的な1時間が鍵。',
      '限界値を一段突破できる日。自分を信じて進んで。',
      '失敗しても立て直しが早い。再挑戦が幸運を呼ぶ。',
      '余裕がなくなると周囲が疲れる日。深呼吸を3回。',
      '依頼を即返答すると流れが次々開けてくる。',
      '勢いの波を逃さないで。今日は「速さ」が正義。'
    ]
  },
  {
    id: 3,
    name: 'セロトニンタイプ',
    subtitle: '安定・調和・継続の人',
    icon: 'ri-water-flash-fill',
    color: '#93c5fd',
    comments: [
      '丁寧さが評価される日。ゆっくりでいいので確実に。',
      '日々の積み重ねが"成果"として見える日。',
      '調整力が光ります。人と人の間に入るとスムーズに。',
      'ルーチンを整えると運気が安定します。',
      '清潔・整頓が幸運の入口。机まわりから着手を。',
      '優しい一言が相手の心を整える日。声かけが吉。',
      '変化より安定を選ぶのが正解。守る日です。',
      '忙しい人の"支え役"に回ると運が味方します。',
      '小さなありがとうが自分を満たす日。',
      '睡眠とリズムを整えると明日の成果につながります。'
    ]
  },
  {
    id: 4,
    name: 'メラトニンタイプ',
    subtitle: '回復・安定・リズムの人',
    icon: 'ri-moon-fill',
    color: '#4c1d95',
    comments: [
      '無理せず、整えることに価値がある日。',
      '休息の提案が喜ばれます。誰かの負荷を軽くできる。',
      '穏やかなペースが吉。焦らないことで成果が出ます。',
      '負担の大きい人に声をかけると良い循環が生まれる。',
      '今日は休息スイッチを入れる日。自分も周囲も整う。',
      'スケジュールの見直しが成功の鍵。詰めすぎ注意。',
      '夕方にかけて心が落ち着き、判断が冴えます。',
      '睡眠を最優先に。明日のリセットが完全に整います。',
      '慌てて決めないこと。夜の静かな時間が吉。',
      '調整役としての魅力が光る。空気を整えて運気UP。'
    ]
  },
  {
    id: 5,
    name: 'ドーパミンタイプ',
    subtitle: '発想・挑戦・革新の人',
    icon: 'ri-lightbulb-flash-fill',
    color: '#ec4899',
    comments: [
      'アイデアが湧きやすい日。メモを常に手元に。',
      '新しい挑戦が運を引き寄せる日。迷わず"やってみる"。',
      'SNS・DX・提案活動に最適。直感が鋭いです。',
      '他の人とは違う視点が評価される日。個性を出してOK。',
      '気分が乗れば最高の成果に。テンポを大切に。',
      '飽きやすい日なので、終える仕組みを先に作ると吉。',
      '将来の計画を考えると良い案が生まれます。',
      '新しい人との出会いが発想を刺激してくれる。',
      '勢いが大事。動きながら考えてOK。',
      '今日は「未来のあなた」を意識して一歩先へ。'
    ]
  },
  {
    id: 6,
    name: 'アセチルコリンタイプ',
    subtitle: '知性・学習・精密の人',
    icon: 'ri-book-open-fill',
    color: '#1d4ed8',
    comments: [
      '複雑な案件を処理すると評価が上がる日。',
      '新しい知識が吸収しやすく、研修に最適。',
      '正確性を武器に丁寧に仕上げると運気が上がる。',
      '論理的説明が相手に刺さる日。教育役が吉。',
      '情報整理に強い日。分類・整理から始めて。',
      '深く考えすぎ注意。70%で一度アウトプットが吉。',
      '疑義照会の判断に自信を持てる日。',
      '新人への説明が相手の理解を深める一日。',
      '学習意欲が高い。気になっていた論文を読むと吉。',
      '"やらないこと"を決めると頭がクリアに。'
    ]
  },
  {
    id: 7,
    name: 'GABAタイプ',
    subtitle: '安心・抑制・穏やかさの人',
    icon: 'ri-leaf-fill',
    color: '#4ade80',
    comments: [
      '焦っている周囲を落ち着かせる力が一番光る日。',
      '穏やかな対応が信頼につながる。急がなくて大丈夫。',
      '聞き役に回ると相手が救われ、あなたも整う。',
      'クレーム処理で大きな成果が出せる日。',
      '人の話をじっくり聞くと、自分へのヒントに。',
      '自分のペースを守ると心が軽くなる。',
      '空気を読む力が強まる日。場を整えると運が動く。',
      '優しい言葉が相手の重荷を軽くします。',
      '自分の意見を一言だけ足すと存在感が出る。',
      '穏やかさが最大の武器。無理なくいきましょう。'
    ]
  },
  {
    id: 8,
    name: 'グルタミン酸タイプ',
    subtitle: '活性化・連携・巻き込みの人',
    icon: 'ri-links-fill',
    color: '#fbbf24',
    comments: [
      '連携が冴える日。調整役に回ると流れがスムーズ。',
      '新しい人脈が広がりやすい。声かけは積極的に。',
      '今日のあなたは"情報ハブ"。会話の中にヒントあり。',
      '多職種連携がうまく進む日。医院訪問も吉。',
      '午後に一気に忙しくなる予感。ただし成果も大きい。',
      'スケジュール詰めすぎ注意。緩衝を10分つくって。',
      '調整ごとで頼られやすい日。引き受けすぎに注意。',
      '情報共有をするとチームが活性化。',
      '新しい企画が仲間を巻き込み成功しやすい。',
      'あなたが動くと雰囲気が変わる。主役に。'
    ]
  },
  {
    id: 9,
    name: 'オキシトシンタイプ',
    subtitle: '共感・支援・つながりの人',
    icon: 'ri-heart-fill',
    color: '#f472b6',
    comments: [
      '人の気持ちがよく見える日。相手を支えると運UP。',
      '患者やスタッフとの対話が深まるタイミング。',
      '在宅訪問や相談業務が成果につながりやすい。',
      '優しい言葉が相手を助ける一日。',
      '困っている人の"最初の相談相手"になれます。',
      '情に流されやすい日。境界線を大切に。',
      '信頼関係が大きく進む日。フォローが吉。',
      '感謝の言葉を伝えると良い循環が生まれる。',
      '人との交流があなたの心を満たす日。',
      '"寄り添う力"が最大の武器。今日はそれが輝きます。'
    ]
  },
  {
    id: 10,
    name: 'エンドルフィンタイプ',
    subtitle: '幸せ・回復・雰囲気の人',
    icon: 'ri-emotion-happy-fill',
    color: '#fde047',
    comments: [
      'ユーモアが周囲を救う日。軽い一言で空気が変わる。',
      '明るさが評価される日。挨拶を少し大きめに。',
      'ちょっとした褒め言葉が相手の力に。',
      '仕事が楽しく感じられる日。勢いに乗って◎',
      '休憩時間に好きなものを食べると運気UP。',
      '場の雰囲気改善が成果につながる日。',
      'SNS発信に向いている日。投稿が伸びやすい。',
      '楽観的に考えると解決策が見える一日。',
      '無理せず"明るい範囲"で働くと調子がよい。',
      'あなたの明るさでチームが元気になる日。'
    ]
  },
  {
    id: 11,
    name: 'コルチゾールタイプ',
    subtitle: '長期戦・持久力・危機管理の人',
    icon: 'ri-shield-fill',
    color: '#475569',
    comments: [
      '粘り強さが大きな成果につながる日。',
      '長期案件の進捗を整理するとスムーズに進む。',
      '冷静さが評価される日。感情より事実を優先して◎',
      '難しい案件が解決に向かうチャンス。',
      '無駄を切り、必要な部分に集中すると吉。',
      'ストレスサインに注意。休息時間を確保して。',
      '交渉・折衝がうまくいくタイミング。',
      '計画の見直しが成功の鍵になる。',
      '感情的な場面でも優位に立てる日。',
      '一歩ずつで構わない。積み重ねが光る日。'
    ]
  },
  {
    id: 12,
    name: 'テストステロンタイプ',
    subtitle: '前進・リーダーシップの人',
    icon: 'ri-arrow-up-fill',
    color: '#dc2626',
    comments: [
      '主導権を握ると流れが良くなる日。',
      '目標設定が明確だと成果が倍増します。',
      '競争環境があなたの力を引き出す一日。',
      '若手の前での発言が影響力を持つ日。',
      'スピード勝負が吉。前に出てOK。',
      '圧が出やすいので、一言柔らかくすると完璧。',
      '獲得・営業に強い日。在宅営業に向いています。',
      '挑戦が評価に直結する。躊躇しないで。',
      'リーダーとしての魅力が光る。指示が通りやすい。',
      '成果を掴める日。前向きに押し切って。'
    ]
  },
  {
    id: 13,
    name: 'エストロゲンタイプ',
    subtitle: '育成・調整・共感リーダー',
    icon: 'ri-flower-fill',
    color: '#c084fc',
    comments: [
      '人の成長を手助けすると運気が一気に上がる。',
      '教える場面が増える日。あなたの言葉が響きます。',
      '調整役として最適。皆が動きやすい空気を作れます。',
      '相手の気持ちを汲むとトラブルが避けられる。',
      '丁寧な指導が結果に繋がる日。OJTに最適。',
      '優しさが評価される。強さは不要な日。',
      '感情の機微を察知しやすい。聞く姿勢が吉。',
      '新人フォローで信頼が深まる日。',
      'ゆっくりでもOK。丁寧が勝ちです。',
      'チームの"空気を整える力"が最大の武器になる。'
    ]
  },
  {
    id: 14,
    name: 'ドーパミンD2タイプ',
    subtitle: '戦略・制御・慎重な判断の人',
    icon: 'ri-chess-fill',
    color: '#166534',
    comments: [
      '戦略思考が冴える日。計画を立てると最強。',
      'リスク管理能力が高まる日。見落としが減る。',
      '冷静な判断が評価されます。感情に引っ張られないで◎',
      '数字を見ると新しい気づきが生まれる。',
      '今日は"分析＞行動"が正解。土台作りに最適。',
      '過分析に注意。70%で一旦アウトプットを。',
      '会議での発言が刺さる。他者が考えていない視点あり。',
      '長期計画を作ると成功率が上がる日。',
      '慎重さが強みになる。焦らず一歩ずつ。',
      '静かに成果が出る。派手さはいらない日。'
    ]
  },
  {
    id: 15,
    name: 'アセチルコリン海馬型タイプ',
    subtitle: '記憶・経験・体系化の人',
    icon: 'ri-brain-fill',
    color: '#92400e',
    comments: [
      '過去の経験が大きなヒントになる日。振り返りを。',
      'パターン認識が鋭い。返戻処理に最適。',
      '情報整理が進む日。分類・統合が吉。',
      '教えると自分の理解も深まる日。教育に向く。',
      '変化より安定を選ぶと成果が出ます。',
      '中途半端な案件を整理するとチームが助かる。',
      '落ち着いた判断ができる。時間をかけてOK。',
      '昔のメモ・資料に重要な気づきが隠れています。',
      '記録をつけると後日の自分を助けます。',
      '今日の積み重ねが"未来の武器"になります。'
    ]
  }
];

interface BrainChemistryType {
  id: number;
  name: string;
  subtitle: string;
  icon: string;
  color: string;
  comments: string[];
  todayComment?: string;
}

export default function BrainChemistryFortune() {
  const [currentType, setCurrentType] = useState<BrainChemistryType | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  // 日替わりラッキータイプを計算
  const getLuckyType = () => {
    const today = new Date();
    const dayOfYear = Math.floor((today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 86400000);
    const luckyTypeIndex = dayOfYear % brainTypes.length;
    const luckyType = brainTypes[luckyTypeIndex];
    const luckyComment = luckyType.comments[dayOfYear % luckyType.comments.length];
    
    return {
      ...luckyType,
      todayComment: luckyComment
    };
  };

  const luckyType = getLuckyType();

  const diagnose = () => {
    setIsLoading(true);
    setCurrentType(null);
    
    // 1秒間のローディング演出
    setTimeout(() => {
      const randomType = brainTypes[Math.floor(Math.random() * brainTypes.length)];
      const randomComment = randomType.comments[Math.floor(Math.random() * randomType.comments.length)];
      setCurrentType({
        ...randomType,
        todayComment: randomComment
      });
      setIsLoading(false);
    }, 1000);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-yellow-300 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-pink-300 rounded-full blur-2xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* ヘッダー */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4 drop-shadow-lg">
              PharmaBeast｜脳内化学タイプ占い
            </h2>
            <p className="text-white/90 text-lg">
              あなたの今日の脳内化学バランスを診断します
            </p>
          </div>

          {/* 今日のラッキータイプ */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 mb-8 shadow-2xl">
            <div className="flex items-center justify-center gap-4 mb-4">
              <i className="ri-star-fill text-3xl text-yellow-500"></i>
              <h3 className="text-2xl font-bold text-gray-800">今日のラッキータイプ</h3>
              <i className="ri-star-fill text-3xl text-yellow-500"></i>
            </div>
            <div className="text-center">
              <div 
                className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-4 shadow-lg"
                style={{ backgroundColor: luckyType.color }}
              >
                <i className={`${luckyType.icon} text-4xl text-white`}></i>
              </div>
              <h4 className="text-2xl font-bold mb-2" style={{ color: luckyType.color }}>
                {luckyType.name}
              </h4>
              <p className="text-gray-600 text-lg">{luckyType.subtitle}</p>
            </div>
          </div>

          {/* 診断ボタン */}
          <div className="text-center mb-8">
            <button
              onClick={diagnose}
              disabled={isLoading}
              className="bg-white text-purple-600 px-12 py-5 rounded-full text-xl font-bold shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isLoading ? (
                <span className="flex items-center gap-3">
                  <span className="inline-block w-6 h-6 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></span>
                  診断中...
                </span>
              ) : (
                <>
                  <i className="ri-brain-line mr-2"></i>
                  あなたの脳内化学タイプを診断
                </>
              )}
            </button>
          </div>

          {/* ローディング表示 */}
          {isLoading && (
            <div className="flex justify-center items-center py-12">
              <div className="relative">
                {/* 虹色のスピナー */}
                <div className="w-24 h-24 rounded-full border-8 border-transparent border-t-red-500 border-r-yellow-500 border-b-green-500 border-l-blue-500 animate-spin"></div>
                <div className="absolute inset-0 w-24 h-24 rounded-full border-8 border-transparent border-t-purple-500 border-r-pink-500 animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s' }}></div>
              </div>
            </div>
          )}

          {/* 診断結果 */}
          {currentType && !isLoading && (
            <div className="relative">
              {/* キラキラパーティクル効果 */}
              <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-2 h-2 bg-yellow-300 rounded-full animate-ping"></div>
                <div className="absolute top-10 right-1/4 w-3 h-3 bg-pink-300 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
                <div className="absolute bottom-10 left-1/3 w-2 h-2 bg-blue-300 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
                <div className="absolute top-1/2 right-1/3 w-3 h-3 bg-purple-300 rounded-full animate-ping" style={{ animationDelay: '0.6s' }}></div>
              </div>

              {/* 結果カード */}
              <div 
                className="bg-white/95 backdrop-blur-sm rounded-3xl p-10 shadow-2xl transform animate-[scaleIn_0.5s_ease-out] relative overflow-hidden"
                style={{
                  boxShadow: `0 0 60px ${currentType.color}40, 0 20px 40px rgba(0,0,0,0.2)`
                }}
              >
                {/* グロー効果 */}
                <div 
                  className="absolute inset-0 opacity-10 blur-3xl"
                  style={{ backgroundColor: currentType.color }}
                ></div>

                <div className="relative z-10">
                  <div className="text-center mb-8">
                    <div className="inline-block relative">
                      {/* アイコンの背景グロー */}
                      <div 
                        className="absolute inset-0 rounded-full blur-2xl opacity-50 animate-pulse"
                        style={{ backgroundColor: currentType.color }}
                      ></div>
                      
                      {/* アイコン */}
                      <div 
                        className="relative inline-flex items-center justify-center w-32 h-32 rounded-full shadow-2xl animate-[spin_1s_ease-out]"
                        style={{ 
                          backgroundColor: currentType.color,
                          animationIterationCount: '1'
                        }}
                      >
                        <i className={`${currentType.icon} text-6xl text-white drop-shadow-lg`}></i>
                      </div>
                    </div>
                    
                    <h4 
                      className="text-4xl font-bold mt-6 mb-3 drop-shadow-md"
                      style={{ color: currentType.color }}
                    >
                      {currentType.name}
                    </h4>
                    <p className="text-gray-600 text-xl font-medium mb-6">
                      {currentType.subtitle}
                    </p>
                    
                    {/* 今日のメッセージ */}
                    <div 
                      className="bg-gradient-to-r from-transparent via-gray-50 to-transparent p-6 rounded-2xl border-2 shadow-lg"
                      style={{ borderColor: `${currentType.color}30` }}
                    >
                      <div className="flex items-start gap-3">
                        <i className="ri-chat-quote-line text-3xl flex-shrink-0 mt-1" style={{ color: currentType.color }}></i>
                        <p className="text-gray-700 text-lg leading-relaxed font-medium">
                          {currentType.todayComment}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* もう一度診断ボタン */}
                  <div className="text-center mt-8">
                    <button
                      onClick={diagnose}
                      className="text-gray-600 hover:text-gray-800 font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-refresh-line mr-2"></i>
                      もう一度診断する
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 説明文 */}
          <div className="text-center mt-8 text-white/80 text-sm">
            <p>※ この占いは脳内化学物質の特性をもとにした楽しいコンテンツです</p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scaleIn {
          0% {
            transform: scale(0.8);
            opacity: 0;
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </section>
  );
}
